import { pick } from 'lodash';
import { Project } from 'api/project';

export const getRelatedValues = (project: Project) =>
  pick(project, [
    'customer',
    'projectName',
    'fields',
    'projectId',
    'startDate',
    'dueDate',
    'source',
  ]);
